module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "finish"
  }, [_c('div', {
    staticClass: "s-form"
  }, [_c('div', {
    staticClass: "s-form-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "s-form-info"
  }, [_c('h5', [_vm._v("恭喜你，" + _vm._s(_vm.finish_title) + "！")]), _vm._v(" "), _c('p', {
    staticClass: "s-form-subtext"
  }, [_vm._v("你的账户安全级别还能提升哦，快去完成其他的安全设置吧！")])])]), _vm._v(" "), _c('div', {
    staticClass: "s-form-btnrow"
  }, [_c('button', {
    staticClass: "s-button s-btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("我知道了")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "s-form-label"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/personal_center/pops-ok.png"),
      "alt": "完成"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7ca6f71d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/finish.vue
// module id = uW8v
// module chunks = 15